module.exports = __webpack_public_path__ + "static/media/training2.555344d7.png";